<template>
  <div class="bg-white rounded-lg border border-gray-200 shadow-sm">
    <div class="px-4 py-3 border-b border-gray-200">
      <h2 class="heading-section">Tools</h2>
    </div>
    <div>
      <ag-grid-vue
        style="width: 100%; height: 100%"
        :theme="theme"
        :columnDefs="columnDefs"
        :rowData="tools"
        :defaultColDef="defaultColDef"
        :grid-options="{ domLayout: 'autoHeight', suppressCellFocus: true }"
        @row-clicked="$emit('open-tool-modal', $event.data.id)"
      />
    </div>
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue3'
import CellStatusBadge from '@/components/Outreach/Cells/CellStatusBadge.vue'
import { formatLabel } from '@/utils/string'
import { standardListTheme } from '@/utils/common'

export default {
  name: 'ToolsCard',
  components: {
    AgGridVue,
  },
  props: {
    tools: {
      type: Array,
      required: true,
    },
  },
  emits: ['open-tool-modal'],
  data() {
    return {
      theme: standardListTheme,
      defaultColDef: {
        flex: 1,
        minWidth: 100,
        resizable: true,
        sortable: true,
        filter: true,
      },
      columnDefs: [
        { field: 'name', headerName: 'Name' },
        { field: 'description', headerName: 'Description', flex: 2 },
        {
          field: 'tool_type',
          headerName: 'Type',
          valueGetter: (params) => formatLabel(String(params.data.tool_type || ''))
        },
        {
          field: 'status',
          headerName: 'Status',
          valueGetter: (params) => formatLabel(String(params.data.status || '')),
          cellRenderer: CellStatusBadge,
          cellRendererParams: {
            variant: 'call-config'
          },
          filter: 'agSetColumnFilter',
        },
      ],
    }
  },
}
</script>
